import { type ICombinedState } from '../reducers';

export const requesterSelector = (state: ICombinedState) => state.requester.requester;
